export default __webpack_public_path__ + "d76165cc733b1371300bb6e1cb611ca0.svg";